export const GEOJSON_FEATURE = 'Feature';

export const GEOJSON_FEATURE_COLLECTION = 'FeatureCollection';

export enum GEOJSON_FEATURE_TYPE {
    POINT = 'Point',
    LINE_STRING = 'LineString',
    POLYGON = 'Polygon'
}

export enum GEOJSON_POLYGON_TYPE {
    CIRCLE = 'circle',
    POLYGON = 'polygon'
}

export enum GEOJSON_BOUNDARY_TYPE {
    APPLY = 'apply',
    NO_APPLY = 'noApply',
    NO_ENTRY = 'noEntry'
}

export enum GEOJSON_PROPERTY {
    NAME = 'name',
    ID = 'id',
    INNER_FEATURE_ID = 'innerFeatureId',
    REFERENCED_BOUNDARY_ID = 'referencedBoundaryId',
    LINKED_NO_ENTRY_ID = 'linkedNoEntryIds',
    LINKED_BOUNDARY_ID = 'linkedBoundaryId',

    // only used for circles
    CENTER_POINT = 'centerPoint',
    // only used for circles
    RADIUS_METERS = 'radiusMeters',

    // the current rendering layer of the feature
    LAYER = 'layer',
    // drawing tool
    POLYGON_TYPE = 'polygonType',
    // drawing mode
    BOUNDARY_TYPE = 'boundaryType',

    // Whether we are actively adding new points
    IS_DRAWING = 'isDrawing',
    IS_SELECTED = 'isSelected',
    // is the geometry static
    IS_STATIC = 'isStatic',
    IS_ACTIVE_BOUNDARY = 'isActiveBoundary',
    CLUSTER = 'cluster',

    EXT_APPLICATION_ID = 'extApplicationId',

    FLIGHT_ID = 'flightId',
    IS_FULL_FLIGHT_PATH = 'isFullFlightPath',

    PART_INDEX = 'partIndex'
}
